import { render, staticRenderFns } from "./ContentsPage.vue?vue&type=template&id=4db4f700"
import script from "./ContentsPage.vue?vue&type=script&lang=js"
export * from "./ContentsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports